import React from 'react';
import PropTypes from 'prop-types';
import EditableCurrency from '@/shared/components/editable/EditableCurrency';
import authService, { privileges } from '@/shared/services/AuthService';

const PriceGridCell = ({ value, onChange }) => (
  <EditableCurrency
    value={value.amount}
    onChange={val => onChange({ ...value, amount: val })}
    readOnly={
      !authService.hasPermission({
        functionality: 'pricelist',
        privilege: privileges.Update,
      })
    }
    maximumFractionDigits={5}
  />
);

PriceGridCell.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PriceGridCell;
